resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function ContentFlip() {
    this.extends = [_ResponsiveLayout, _ContentLayout];
    this.priority = 1001;
    this.id = null;
    this.node = null;
    this.declaredClass = null;

    // Parameters
    this.axis = "y";


    // Vars
    this._frontNode = null;
    this._backNode = null;
    this._wrapper = null;

    this.init = function() {
        // Detect touch
        if ($("html.touch").length > 0)
            this._touch = true;

        // Add content-wrapper
        this._wrapper = $("<div class='content-wrapper'></div>");
        $(this._wrapper).appendTo(this.node);

        // Add class
        $(this.node).addClass("mogo-ui-content-flip " + this.axis + "-axis");
        $(this._wrapper).addClass("content-wrapper");

        // Role link
        $(this.node).attr("role", "link");

        // Get front/back nodes
        if ($(".front", this.node).length < 1)
            console.error("Cannot find front view for flip content: " + this.id);
        else
            this._frontNode = $(".front", this.node);
        if ($(".back", this.node).length < 1)
            console.error("Cannot find back view for flip content: " + this.id);
        else
            this._backNode = $(".back", this.node);
        $(this._frontNode).appendTo(this._wrapper);
        $(this._backNode).appendTo(this._wrapper);

        // Register responsive function
        this.registerResponsiveFunction($.proxy(this.resize, this), null, null);

        // Connections
        $(this.node).on("click", $.proxy(this.flip, this));
    };

    this.initAllReady = function() {
        // Show container
        $(this.node).css("visibility", "hidden");
        $(this.node).css("display", "block");
        this.resize();
        $(this.node).css("visibility", "visible");
    };

    this.flip = function() {
        if ($(this.node).hasClass("flipped") || $(this.node).hasClass("flipped-done")) {
            $(this.node).addClass("default");
            $(this.node).removeClass("flipped-done");
            $(this.node).removeClass("flipped");
            setTimeout($.proxy(function() {$(this.node).removeClass("default");}, this), 500);
        } else {
            $(this.node).addClass("flipped");
            $(this.node).removeClass("default");
            setTimeout($.proxy(function() {
                $(this.node).addClass("flipped-done");
                $(this.node).removeClass("flipped");
            }, this), 500);
        }
    };

    this.resize = function() {
        $(this.node).css("height", "auto");
        $(this._wrapper).css("height", "auto");
        $(this._frontNode).css("height", "auto");
        $(this._backNode).css("height", "auto");
        var maxHeight = 0;
        maxHeight = Math.max($(".front", this.node).height(), $(".back", this.node).height());
        $(this.node).css("height", maxHeight + "px");
        $(this._wrapper).css("height", maxHeight + "px");
        $(this._frontNode).css("height", maxHeight + "px");
        $(this._backNode).css("height", maxHeight + "px");

        // Add perspective
        if (this.axis == "x") {
            $(this.node).css("-webkit-perspective", $(this.node).width() * 2 + "px");
            $(this.node).css("perspective", $(this.node).width() * 2 + "px");
        } else if (this.axis == "y") {
            $(this.node).css("-webkit-perspective", $(this.node).height() * 4 + "px");
            $(this.node).css("perspective", $(this.node).height() * 4 + "px");
        }
    };

    this.reLayout = function() {
        this.resize();
    }
}